import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.BANKASSURANCE_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ***********************************************
*                     SUBSCRIBE                  *
*********************************************** */
{
	path: routeList.BANKASSURANCE_SUBSCRIBE_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_NAME,
	props: true,
	component: () => import('@/views/ThirdLevelMenu')
}, {
	path: routeList.BANKASSURANCE_SUBSCRIBE_TRAVEL_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_TRAVEL_NAME,
	component: () => import('@/views/bankassurance/subscribe/Travel')
}, {
	path: routeList.BANKASSURANCE_SUBSCRIBE_AUTO_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_AUTO_NAME,
	component: () => import('@/views/bankassurance/subscribe/Auto')
}, {
	path: routeList.BANKASSURANCE_SUBSCRIBE_HEALTH_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_HEALTH_NAME,
	component: () => import('@/views/bankassurance/subscribe/Health')
},
/* ******************* ************************ */
{
	path: routeList.BANKASSURANCE_POLICIES_PATH,
	name: routeList.BANKASSURANCE_POLICIES_NAME,
	component: () => import('@/views/bankassurance/Policies')
}]
